import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateDocumentationComponent } from './update-documentation.component';
import { RequestsSharedModule } from '../@shared';
import { MaterialModule } from '@app/material.module';
import { UpdateDocumentationRoutingModule } from './update-documentation-routing.module';
import { UpdateComponent } from '../@shared/update/update.component';
import { SharedModule } from '@app/@shared';

@NgModule({
  imports: [CommonModule, RequestsSharedModule, UpdateDocumentationRoutingModule, SharedModule, MaterialModule],
  declarations: [UpdateDocumentationComponent, UpdateComponent],
})
export class UpdateDocumentationModule {}
